export default "__VITE_ASSET__b0095064__"